"use client";

import * as stylex from "@stylexjs/stylex";
import * as React from "react";
import { Code } from "timvir/blocks";
import { useArticleComponents } from "timvir/core";
import { layoutStyles } from "../../../core/layout";
import * as Icons from "../../../icons";
export function Caption(props) {
  const components = useArticleComponents();
  const {
    src,
    code
  } = props;
  const [codeRef, setCodeRef] = React.useState(null);
  return <>
      <figcaption {...stylex.props(layoutStyles.block, styles.figcaption)}>
        <div>
          Source:{" "}
          <components.a href={src} target="_blank" rel="noopener">
            {src}
          </components.a>
        </div>

        {code && <div className="x1ypdohk xgmrl4 x1o7uuvo" onClick={() => {
        if (codeRef) {
          const infoParent = codeRef.parentElement;
          if (!infoParent) {
            return;
          }
          if (infoParent.style.height === "0px") {
            infoParent.style.height = `${codeRef.getBoundingClientRect().height}px`;
            infoParent.style.opacity = "1";
          } else {
            infoParent.style.height = "0px";
            infoParent.style.opacity = "0";
          }
        }
      }}>
            <Icons.Code width={"1.6em"} height={"1.6em"} className="x1lliihq" />
          </div>}
      </figcaption>

      {code && <div className="xb3r6kr x104cjix xqtp20y xg01cxk">
          <div ref={setCodeRef} className="x14vqqas">
            <Code language="jsx">{code}</Code>
          </div>
        </div>}
    </>;
}
const styles = {
  figcaption: {
    kGuDYH: "x1dcheo9",
    kLWn49: "xjkpybl",
    kMwMTN: "xvgvpxu",
    khDVqt: "xuxw1ft",
    k1xSpc: "x78zum5",
    kjj79g: "x1qughib",
    kGNEyG: "x6s0dn4",
    $$css: true
  }
};